import React from 'react';
import PropTypes from 'prop-types';

/**
 * Rotation list:
 * This component rotates a list of values with a 5-second interval and usually it is
 * encapsulated into the component BoxSingleData or SingleData
 * @param array list: list of values to be displayed
 */
export default class RotationList extends React.PureComponent {
  constructor(props) {
    super(props);
    const value = props.list.length > 0 ? props.list[0] : '';
    this.state = {
      value,
      index: 0,
    };
  }

  componentDidMount() {
    setInterval(() => {
      let { index } = this.state;
      const { list } = this.props;
      const value = list.length > 0 ? list[index] : '';
      index = index === list.length - 1 ? 0 : index + 1;
      this.setState({ value, index });
    }, 5000);
  }

  render() {
    const { value } = this.state;
    return value;
  }
}

RotationList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string).isRequired,
};
